import { graphql } from 'gatsby';
import { PostDetailsLayout, createGatsbyPageComponent } from '@shapeable/ui';
import { PostLayout } from '../../components/entities/post-layout';

export default createGatsbyPageComponent('Post', { layout: PostLayout });

export const QUERY = graphql`
query PostQuery($id: ID!) {
  platform { post(id: $id) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel } 
    title 
    pretitle
    subtitle
    published
    content { plain text }
    openGraph { title description { plain } image { url url2x thumbnails { halfBanner { url url2x } card { url url2x } bubble { url url2x } } } }
    content { id text }
    intro { plain text }
    outro { text }
    authors { 
      id name slug path __typename
      photo { id url url2x type }
    }
    videos {
      id name url
      thumbnail { id url url2x type }
    }
    imageAssets {
      id name image { id url url2x type }
    }
    organisations {
      id name slug path
      logo { id url url2x type }
    }
    people {
      id name slug path
      organisation { id name }
      linkedin
      position
      photo { id url url2x type }
    }
    embeds {
      citations {
        slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
      }
      pages {
        id name slug path
        openGraph {
          title description { plain }
          image { url url2x type }
        }
      }
      people {
        id name slug path
        organisation { id name }
        position
        photo { id url url2x }
      }
      imageAssets {
        id
        slug
        image {
          id url url2x width height type
        }
      }
    }
  } }
}
`;
